import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CirctuitRoomingListParamsState } from "../objects/circuitRoomingListParamsState";
import { RoomingListParams } from "../objects/roomingListParams";
import { EMPTY_ROOMING_LIST_PARAMS_CRITERIA } from "../constants/circuitRoomingListParamsConstant";
import { RoomingListParamsListCriteria } from "../objects/roomingListParamsList";

const initialState: CirctuitRoomingListParamsState = {
    rooming_list_params: null,
    rooming_list_params_list: [],
    rooming_list_params_list_criteria: EMPTY_ROOMING_LIST_PARAMS_CRITERIA,
    rooming_list_params_list_count: 0,

    variable_list: {},

}

const updateRoomingListParamsReducer = (state: CirctuitRoomingListParamsState, action: PayloadAction<null | RoomingListParams>): CirctuitRoomingListParamsState => ({
    ...state, rooming_list_params: action.payload
});
const updateRoomingListParamsListReducer = (state: CirctuitRoomingListParamsState, action: PayloadAction<RoomingListParams[]>): CirctuitRoomingListParamsState => ({
    ...state, rooming_list_params_list: action.payload
});
const updateRoomingListParamsListCountReducer = (state: CirctuitRoomingListParamsState, action: PayloadAction<number>): CirctuitRoomingListParamsState => ({
    ...state, rooming_list_params_list_count: action.payload
});
const updateRoomingListParamsListCriteriaReducer = (state: CirctuitRoomingListParamsState, action: PayloadAction<RoomingListParamsListCriteria>): CirctuitRoomingListParamsState => ({
    ...state, rooming_list_params_list_criteria: action.payload
});

const updateVariablesListReducer = (state: CirctuitRoomingListParamsState, action: PayloadAction<Record<string, Record<string, string>>>): CirctuitRoomingListParamsState => ({
    ...state, variable_list: action.payload
});


export const circuitRoomingListParamsSlice = createSlice({
    name: 'circuit_rooming_list_params',
    initialState,
    reducers: {
        updateRoomingListParams: updateRoomingListParamsReducer,
        updateRoomingListParamsList: updateRoomingListParamsListReducer,
        updateRoomingListParamsListCriteria: updateRoomingListParamsListCriteriaReducer,
        updateRoomingListParamsListCount: updateRoomingListParamsListCountReducer,
        updateVariablesList: updateVariablesListReducer,
    }
});

export const {
    updateRoomingListParams,
    updateRoomingListParamsList,
    updateRoomingListParamsListCriteria,
    updateRoomingListParamsListCount,
    updateVariablesList
} = circuitRoomingListParamsSlice.actions;

